import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
    name: 'PasswordRequirement',
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    valid;
    @Prop({ required: true })
    notEmpty;
    @Prop({ default: false })
    showError;
    get error() {
        return this.notEmpty && !this.valid && this.showError;
    }
    get success() {
        return this.notEmpty && this.valid;
    }
    get icon() {
        if (this.success)
            return 'CheckmarkIcon';
        else if (this.error)
            return 'TimesIcon';
        else
            return 'CircleIcon';
    }
}
